import styled from "styled-components";
import React, { useState, useEffect } from "react";
import { Route, matchPath } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import { withMedia } from "react-media-query-hoc";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import toast, { Toaster } from "react-hot-toast";
import qs from "qs";

import Error from "../error";
import AuthWrap from "../auth/auth-wrap";
import { TicketPage } from "../ticket/page";
import BlockMenu from "./menu/top";
import BlockLanding from "../block/list";
import BlockDetailsContainer from "../block/details-container";
import { SideMenu } from "./menu/side";
import { GlobalEstateList } from "../estate/list";
import { reverse, routes } from "../../routes";
import { blockManager, getListError } from "../../redux/modules/blocks";
import { fetchUsers } from "../../redux/modules/user";
import { ManagementPage } from "../management/management-page";
import { fetchSettings } from "../../redux/modules/app-settings";
import getJSONGlobals from "safe-json-globals/get";
import { getCurrentLanguage, t } from "../../constant/translations";

const StyledBlockContainer = styled.div`
  height: 100%;
  background-color: #eeeeee;
`;

const AppContainer = ({
  media,
  location,
  blocks,
  error,
  selected,
  fetchSettings,
  fetchUsers,
  fetchBlocks,
}) => {
  const [sideMenu, setSideMenu] = useState(false);

  useEffect(() => {
    fetchSettings();
    fetchUsers();
    if (!blocks) {
      fetchBlocks();
    }

    // Show maintenance toast after a short delay to ensure Toaster is mounted
    const showMaintenanceToast = () => {
      const maintenanceMode = getJSONGlobals("maintenance_mode");

      if (maintenanceMode) {
        const maintenanceMessageBg = getJSONGlobals("maintenance_message_bg");
        const maintenanceMessageEn = getJSONGlobals("maintenance_message_en");
        const currentLanguage = getCurrentLanguage();
        const maintenanceMessage =
          currentLanguage === "bg-BG"
            ? maintenanceMessageBg
            : maintenanceMessageEn;
        const headerText = t("maintenance.mode.header");

        toast(
          (toastObj) => (
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "8px",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  flex: 1,
                }}
              >
                <strong>{headerText}</strong>
                <div>{maintenanceMessage}</div>
              </div>
              <button
                onClick={() => toast.dismiss(toastObj.id)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#856404",
                  cursor: "pointer",
                  fontSize: "18px",
                  padding: "0",
                  lineHeight: "1",
                  fontWeight: "bold",
                }}
              >
                ×
              </button>
            </div>
          ),
          {
            id: "maintenance-toast",
            duration: Infinity,
            icon: "⚠️",
            style: {
              background: "#fff3cd",
              color: "#856404",
              border: "1px solid #ffeeba",
              maxWidth: "600px",
            },
          }
        );
      }
    };

    setTimeout(showMaintenanceToast, 1000);
  }, []);

  const params = qs.parse(location.search, { ignoreQueryPrefix: true });
  const docked = media.desktop && !params.wide;

  if (!blocks) {
    return <Loader active />;
  }
  if (error) {
    return <Error error={error} />;
  }

  return (
    <>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            marginBottom: "10px",
          },
        }}
      />
      <StyledBlockContainer>
        <SideMenu
          visible={sideMenu || docked}
          docked={docked}
          blocks={blocks}
          selected={selected}
          toggleVisibility={setSideMenu}
        >
          <BlockMenu
            toggleVisibility={() => setSideMenu(!sideMenu)}
            sideMenuVisible={sideMenu}
            sideMenuDocked={docked}
            overlay={Boolean(
              matchPath(location.pathname, {
                path: routes.blockDetails,
                exact: true,
              })
            )}
          />
          <Route path={routes.blockList} component={BlockLanding} />
          <Route path={routes.estateList} component={GlobalEstateList} />
          <Route path={routes.manage} component={ManagementPage} />
          <Route
            path={routes.tickets}
            render={(props) => <TicketPage globalView={true} {...props} />}
          />
          <Route path={routes.blockBase} component={BlockDetailsContainer} />
        </SideMenu>
      </StyledBlockContainer>
    </>
  );
};

const mapStateToProps = (state) => {
  const blockState = state.blocks;
  return {
    user: state.auth.user,
    blocks: blockState.entities,
    error: getListError(blockState),
    selected: blockState.selected,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(
    {
      fetchSettings,
      fetchUsers,
      fetchBlocks: () => (dispatch) => {
        dispatch(blockManager.actions.list()).then((result) => {
          if (!result || !result.result) return;
          const singleBlock = result.result.length === 1;
          const shouldRedirect = [routes.baseURL, routes.blockList].includes(
            ownProps.location.pathname
          );

          if (shouldRedirect) {
            if (singleBlock) {
              const blockId = result.result[0].id;
              ownProps.history.replace(
                reverse(routes.blockDetails, { blockId })
              );
            } else {
              ownProps.history.replace(routes.blockList);
            }
          }
        });
      },
    },
    dispatch
  );
};

export const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(withMedia(AuthWrap(withRouter(AppContainer))));
